import { add } from 'date-fns';
import { SET_DID_ONBOARD_NETWORTH, SET_FEED_PERSONALIZATION, SET_LAST_REVIEW_SESSION_COUNT, SET_DID_CLOSE_POTS_CTA_FROM_POTS, SET_DID_CLOSE_POTS_CTA_FROM_ANALYTICS, SET_DID_CLOSE_POTS_CTA_FROM_BUDGETING, SET_DID_CLOSE_POTS_CTA_FROM_TRANSACTIONS, SET_DEVICE_SETTINGS_KEY, SET_DID_CLOSE_UPGRADE_NETWORTH, SET_TRANSACTION_FILTERS, SET_TABS_PERSONALIZATION, } from 'actions/types/deviceSettings';
import { BUDGETING_PERIOD_CHANGED, LOGGED_OUT, SET_HAS_DISMISSED_MAXIMISE_TRIAL_FEED, } from 'actions/types';
import { YEARLY_REPORT_FEED, YEARLY_REPORT_INTRO, } from 'actions/deviceSettingTypes';
import { CREATE_TRADING_ACCOUNT_SUCCESS } from 'features/invest/actions/types';
import { STOCK_DEFAULT_CHART } from 'features/invest/constants';
import { SELECTED_SPACE } from 'features/spaces/constants';
export const initialState = {
    lastReviewSessionCount: undefined,
    didCloseOpenPotsCTAFromPots: false,
    didCloseOpenPotsCTAFromAnalytics: false,
    didCloseOpenPotsCTAFromBudgeting: false,
    didCloseOpenPotsCTAFromTransactions: false,
    feedPersonalization: undefined,
    tabsPersonalization: undefined,
    didViewFraudDetectionIntro: false,
    didViewSmartRulesIntro: false,
    didCloseSmartRulesCard: false,
    didViewTrueBalanceIntro: false,
    didViewGroupsIntro: false,
    didSeeCreditScoreSpotlight: false,
    didSeePayFeedSpotlight: false,
    didOnboardNetworth: false,
    didCloseUpgradeNetWorthCTA: false,
    didOpenPayTab: false,
    didOpenSaveTab: false,
    didOpenInvestTab: false,
    didOpenUpgradeTab: false,
    didOpenBorrowTab: false,
    didCloseConsolidateDebtBanner: false,
    didCloseUpgradeFXCTAInInvest: false,
    didCloseUpgradePotsInterestCTAInInvest: false,
    didSetPeriod: false,
    hasTriedSettingsUpPots: false,
    hasTriedSettingsUpInvest: false,
    didViewSellStopOrderIntro: false,
    didViewSellLimitOrderIntro: false,
    didViewSecclMigrationIntro: false,
    hideScrambleModal: false,
    flipToScramble: true,
    hasAccelerometerSupport: false,
    transactionFilters: {
        selectedAccountsObj: {},
        showExcludedTxns: true,
    },
    investStockChartSettings: {
        chart: STOCK_DEFAULT_CHART,
        shouldShowBuyAndSell: false,
    },
    hideSpaceReminderModal: false,
    lastCategoryEditToastTime: null,
    shouldSeeIntroductoryGiftDiscountScreen: false,
    transactionSortMethod: undefined,
    showSetUpFlow: false,
    [YEARLY_REPORT_INTRO]: false,
    [YEARLY_REPORT_FEED]: false,
    dismissedMaximiseTrialFeedMs: null,
    introGiftFeedDismissedAt: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_TRADING_ACCOUNT_SUCCESS:
        case 'CLOSE_USER_TRADING_ACCOUNT_SUCCESS_ACTION': {
            return {
                ...state,
                hasTriedSettingsUpInvest: false,
            };
        }
        case SET_DID_ONBOARD_NETWORTH:
            return { ...state, didOnboardNetworth: true };
        case SET_DID_CLOSE_UPGRADE_NETWORTH:
            return { ...state, didCloseUpgradeNetWorthCTA: true };
        case SET_LAST_REVIEW_SESSION_COUNT:
            return {
                ...state,
                lastReviewSessionCount: action.lastReviewSessionCount,
            };
        case SET_DID_CLOSE_POTS_CTA_FROM_ANALYTICS: {
            return {
                ...state,
                didCloseOpenPotsCTAFromAnalytics: true,
            };
        }
        case SET_DID_CLOSE_POTS_CTA_FROM_BUDGETING: {
            return {
                ...state,
                didCloseOpenPotsCTAFromBudgeting: true,
            };
        }
        case SET_DID_CLOSE_POTS_CTA_FROM_TRANSACTIONS: {
            return {
                ...state,
                didCloseOpenPotsCTAFromTransactions: true,
            };
        }
        case SET_DID_CLOSE_POTS_CTA_FROM_POTS: {
            return {
                ...state,
                didCloseOpenPotsCTAFromPots: true,
            };
        }
        case SET_FEED_PERSONALIZATION: {
            return {
                ...state,
                feedPersonalization: action.feedPersonalization,
            };
        }
        case SET_TABS_PERSONALIZATION: {
            return {
                ...state,
                tabsPersonalization: action.tabsPersonalization,
            };
        }
        case SET_DEVICE_SETTINGS_KEY: {
            if (action.key && action.value !== undefined) {
                return {
                    ...state,
                    [action.key]: action.value,
                };
            }
            return state;
        }
        case BUDGETING_PERIOD_CHANGED: {
            return {
                ...state,
                didSetPeriod: true,
            };
        }
        case SELECTED_SPACE: {
            return {
                ...state,
                transactionFilters: undefined,
            };
        }
        case SET_TRANSACTION_FILTERS:
            return {
                ...state,
                transactionFilters: action.filters,
            };
        case SET_HAS_DISMISSED_MAXIMISE_TRIAL_FEED:
            return {
                ...state,
                dismissedMaximiseTrialFeedMs: action.payload.forever
                    ? add(new Date(), { days: 7 }).getTime()
                    : new Date().getTime(),
            };
        case LOGGED_OUT:
            return { ...initialState, showSetUpFlow: state.showSetUpFlow };
        default:
            return state;
    }
};
export default reducer;
